import { createHttpClient } from './http'
import { getApiBase } from './config'
import { recipeClient } from './recipes'
import { executionClient } from './executions'

export const createApi = (options = {}) => {
  const baseUrl = options.baseUrl !== undefined ? options.baseUrl : getApiBase()
  const http = createHttpClient({
    baseUrl,
    headers: options.headers,
    retries: options.retries,
    retryDelay: options.retryDelay,
    timeout: options.timeout,
  })
  return {
    http,
    recipe: recipeClient(http),
    execution: executionClient(http),
  }
}
